// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"254f82f2","605":"4e5a66fe","809":"62452d41","981":"5d36d9ff"}[chunkId] + ".chunk.js";
};